import { Children } from 'react';
import { createPortal } from 'react-dom';
import { useV3Shell } from './V3ShellContext';

// The page's control bar: the first thing in the content area on every page. AppHeader hands it the page's own header slots
// (the buttons, filters and tabs the page already has), so every existing control keeps working, just in the V3 place.
// Each argument is a node or an array of nodes; empty ones are ignored. Nothing is hidden: the bar wraps instead of scrolling,
// so dropdowns opened from it are never clipped. It uses flat glass (no backdrop-filter) so modals opened from its controls
// position against the screen, not against this bar.
const V3PageToolbar = ({ left, center, right }) => {
  const shell = useV3Shell();
  const slot = shell && shell.toolbarSlot;
  if (!slot) return null;

  const leftItems = Children.toArray(left);
  const centerItems = Children.toArray(center);
  const rightItems = Children.toArray(right);
  if (leftItems.length === 0 && centerItems.length === 0 && rightItems.length === 0) return null;

  return createPortal(
    <div className="v3-glass v3-glass--flat v3-toolbar" data-testid="v3-page-toolbar">
      <div className="v3-toolbar-group v3-toolbar-left">{leftItems}</div>
      <div className="v3-toolbar-group v3-toolbar-center">{centerItems}</div>
      <div className="v3-toolbar-group v3-toolbar-right">{rightItems}</div>
    </div>,
    slot,
  );
};

export default V3PageToolbar;
